import { useMemo } from "react";
import { Chart } from "@highcharts/react";
import { useTranslation } from "react-i18next";
import getMetricSpec from "../../merchandising/utils/metrics";

const BuyabilityChart = ({ buyabilityData }) => {
  const { t } = useTranslation(["merchandising"]);
  const buyabilityChartOptions = useMemo(() => {
    if (!buyabilityData) {
      return null;
    }
    const categories = ["D (0-25)", "C (26-50)", "B (51-75)", "A (76-100)"];
    const listings = buyabilityData.map((item) => item.buyability_count).splice(0, 4);
    const cr = buyabilityData.map((item) => item.cr * 100).splice(0, 4);
    const crSeriesName = t(($) => $.merchandising["CR"]);
    return {
      chart: {
        type: "column",
        height: 260,
      },
      legend: { enabled: false },
      title: {
        text: null,
      },
      xAxis: {
        categories: categories,
        crosshair: true,
        title: {
          text: null,
        },
      },
      yAxis: [
        {
          min: 0,
          title: {
            text: t(($) => $.merchandising["Conversion Rate"]),
          },
        },
        {
          min: 0,
          title: {
            text: t(($) => $.merchandising["Number of Listings"]),
          },
          opposite: true,
        },
      ],
      tooltip: {
        headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
        pointFormatter: function () {
          return `<tr><td style="padding-right: 10px;">${
            this.series.name
          }: </td><td style="color:${this.color}">&nbsp;<b> ${this.y.toFixed(
            2,
          )}${this.series.name === crSeriesName ? "%" : ""}</b></td></tr>`;
        },
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
      },
      plotOptions: {
        column: {
          pointPadding: 0.2,
          borderWidth: 0,
        },
      },
      series: [
        {
          name: t(($) => $.merchandising["# Listings by Score Range"]),
          data: listings,
          color: getMetricSpec("buyability_score").color,
          yAxis: 1,
        },
        {
          type: "spline",
          name: crSeriesName,
          data: cr,
          color: getMetricSpec("conversion_rate").color,
        },
      ],
    };
  }, [buyabilityData, t]);

  if (!buyabilityChartOptions) {
    return null;
  }

  return <Chart options={buyabilityChartOptions} />;
};

export default BuyabilityChart;
